module.exports = __webpack_public_path__ + "media/metronic/_theme/media/logos/logo-dark-f864132f55d68c8c3509834d13febd26.png";